<template>
    <div>
        <section class="row-section">
            <switch-checkbox title="Анимация" row v-model="animation.enable" style="margin-bottom: 20px" />

            <div class="grid-container" :class="{ disabled: !animation.enable }">
                <div
                    class="animate-item"
                    v-for="(item, n) of animationsList"
                    :class="{
                        [` has-animation has-animation-${[item.value]}`]:
                            animation.type === item.value && animation.enable
                    }"
                    :key="n"
                    @click="chooseAnimate(item.value)"
                >
                    {{ item.label }}
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import SwitchCheckbox from "../../../../../../common/components/form/SwitchCheckbox";
import { animationsList } from "./animations";

export default {
    name: "TaplinkBtnAnimation",
    components: {
        SwitchCheckbox
    },
    props: {
        animation: {}
    },
    data() {
        return {
            animationsList
        };
    },
    methods: {
        chooseAnimate(type) {
            this.animation.type = type;
        }
    }
};
</script>

<style scoped lang="scss">
.grid-container {
    grid-template-columns: 1fr 1fr;
    @media (min-width: 769px) {
        grid-template-columns: 1fr 1fr 1fr;
    }
    &.disabled {
        pointer-events: none;
        opacity: 0.5;
    }
    .animate-item {
        position: relative;
        padding: 10px;
        text-align: center;
        background: #829199;
        color: #fff;
        border-radius: 3px;
        cursor: pointer;
        font-size: 14px;
        white-space: nowrap;
        &.has-animation {
            background-color: #5db85b;
            overflow: hidden;
        }
    }
}
@import "animation";
</style>
